import angular from 'angular';
import {
  loaderService,
  ssDialogService,
  orgDataService,
  userService,
} from 'app/services';
import {
  alerts,
  importDocument,
  actionIcon,
} from 'app/components/global';

import controller from './dashboard-summary.controller';
import directive from './dashboard-summary.directive';
import dashBoardDetailDialog from '../dialog.dashBoardDetailDialog';


export const routeConfig = {
  template: require('./dashboard-summary.html'),
  controller: 'DashboardSummaryController',
  controllerAs: 'dashboardSummaryVM',
};

export default angular.module('app.components.dashboard.dashboardSummary', [
  alerts,
  actionIcon,
  importDocument,
  loaderService,
  orgDataService,
  ssDialogService,
  userService,
  dashBoardDetailDialog
  // dashboardCarousel
])
  .directive('dashboardSummary', directive)
  .controller('DashboardSummaryController', controller)
  .name;

console.log('app.components.dashboard.dashboardSummary created');
